import React from 'react';
import HeroSection from '../components/home/HeroSection/HeroSection';
import AboutPreview from '../components/home/AboutPreview/AboutPreview';
import ServicesPreview from '../components/home/ServicesPreview/ServicesPreview';
import RealisationsPreview from '../components/home/RealisationsPreview/RealisationsPreview';
import CooperativePreview from '../components/home/CooperativePreview/CooperativePreview';
import FinalCTA from '../components/home/FinalCTA/FinalCTA';
import ContactPreview from '../components/home/ContactPreview/ContactPreview';

function Home() {
  return (
    <>
      <HeroSection />
      <AboutPreview />
      <RealisationsPreview />
      <CooperativePreview />
      <ServicesPreview />
      <FinalCTA />
      <ContactPreview />
    </>
  );
}

export default Home;
